import { useLocation } from "react-router-dom";

export function useQueryAppendedUrl(url) {
  const location = useLocation();

  const params = location.search;

  return `${url}${params}`;
}
